var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 294 264"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C3FBF1",
  d: "M268.558 51.746 78.881 41.05c-13.513-.762-25.086 9.566-25.848 23.067l-9.137 161.767c-.763 13.501 9.574 25.064 23.086 25.826l189.678 10.696c13.513.761 25.085-9.566 25.848-23.068l9.137-161.766c.762-13.502-9.574-25.064-23.087-25.826"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "m242.836 50.51 26.323 1.485c13.166.742 23.253 12.026 22.51 25.18l-9.21 163.053c-.741 13.12-12.003 23.171-25.135 22.431l-26.384-1.488 11.899-210.66z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 4.051,
  d: "M219.997 139.39c13.464 22.842 10.926 43.388-25.615 29.721-10.002-3.739-61.943-22.213-54.334-9.241 1.101 1.876 19.631 6.864 18.49 8.099-2.974 3.224-7.68 1.087-6.914 6.803.111.818 7.674 1.966 8.094 2.847.571 1.193-6.642 4.275-5.369 5.589.457.47 8.277 1.75 8.837 2.235 1.181 1.027-9.508 5.067-8.367 5.821 1.213.8 42.196 35.366 78.814 34.419 39.549-1.022 39.362-25.758 40.299-35.482.761-7.909-2.047-26.182-5.699-37.64"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF662F",
  d: "m202.812 13.795-13.401 5.632c-1.286.863-3.365.388-3.877-.89l-10.017-16.44c-1.038-2.586-5.745-2.852-7.07-.398l-12.112 15.297c-.655 1.212-2.773 1.452-3.954.449l-12.751-7.376c-1.431-1.216-4.03-.559-4.122 1.04l9.198 23.533c-.084 1.446 1.921 1.971 3.611 2.014l42.734 2.398c1.717.182 3.661.087 3.721-1.335l12.017-22.44c.069-1.594-2.43-2.523-3.98-1.481z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M95.597 107.862a10 10 0 0 1-.296 1.889l-18.825-1.063a9.7 9.7 0 0 1-.08-1.911c.299-5.293 4.842-9.346 10.145-9.048 5.298.298 9.354 4.837 9.056 10.13zM199.154 113.707a10 10 0 0 1-.295 1.889l-18.826-1.063a9.8 9.8 0 0 1-.079-1.911c.299-5.293 4.841-9.347 10.144-9.048 5.298.298 9.355 4.837 9.056 10.13z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 6.323,
  d: "M116.622 110.955c-.52 9.186 6.507 17.055 15.703 17.574 9.194.52 17.072-6.51 17.59-15.695"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 4.051,
  d: "M41.905 173.803c-13.651 2.117-47.07 24.642-38.49 44.198 10.76 24.523 35.659 14.722 41.937 11.98"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF662F",
  d: "M99.117 208.314H61.551c-3.438 0-6.254-2.81-6.254-6.248l-19.71-76.062c0-3.436 2.813-6.249 6.254-6.249h37.566c3.439 0 4.873 1.367 6.254 6.249l19.71 76.062c0 3.435-2.813 6.248-6.254 6.248"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 4.051,
  d: "M44.295 186.71c-2.85-.839-4.91-2.52-5.48-4.806-.726-2.918 1.157-6.098 4.572-8.433 1.767-1.214 3.948-2.196 6.386-2.803 2.258-.562 4.471-.731 6.478-.562 4.348.37 7.715 2.33 8.468 5.357.464 1.871-.14 3.842-1.53 5.631"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 4.051,
  d: "M57.72 197.135c7.154-1.778 12.06-6.808 10.958-11.235s-7.795-6.574-14.949-4.795c-7.153 1.778-12.06 6.808-10.957 11.234s7.795 6.574 14.949 4.796ZM56.248 170.106c3.415-2.335 5.293-5.512 4.572-8.428-.615-2.478-2.984-4.243-6.204-5.003M43.387 173.47c-4.345-.367-7.718-2.327-8.47-5.357-.78-3.15 1.474-6.607 5.416-8.977"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 4.051,
  d: "M45.97 147.6c5.791-1.441 11.132-.008 11.932 3.201.491 1.971-.845 4.148-3.288 5.876-2.533-.604-5.594-.58-8.745.204-2.062.514-3.94 1.298-5.54 2.261-1.791-.628-3.046-1.702-3.4-3.127-.8-3.209 3.252-6.974 9.038-8.413z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4.051,
  d: "m33.435 105.098-5.876-14.89M25.726 109.751 14.3 98.668M20.014 117.491l-15.387-2.916"
})));
export default SvgPhone;